module.exports = __webpack_public_path__ + "img/dinosaur_half.402e915c.svg";